import { useState } from 'react';
import styled, { css } from 'styled-components';
import { NavLink, useLocation } from 'react-router-dom';

const SideNav = () => {
  const location = useLocation();

  const [navOpen, setNavOpen] = useState({
    1: location.pathname.startsWith('/client'),
    2: location.pathname.startsWith('/workforce'),
    3: location.pathname.startsWith('/storage'),
    4: location.pathname.startsWith('/admin'),
  });

  const toggleNav = (navNumber) => {
    setNavOpen(prevState => ({
      ...prevState,
      [navNumber]: !prevState[navNumber]
    }));
  };

  return (
    <>
      <NavWrap>
        <NavList>
          <ListItem>
            <ListBtn onClick={() => toggleNav(1)} $isOpen={navOpen[1]}>
              Client management
            </ListBtn>
            <DepthList $isOpen={navOpen[1]}>
              <Depth>
                <NavLink
                  to='/client/management'
                  end={true}
                  className={({ isActive }) => {
                    return isActive || location.pathname === '/' ? 'active' : '';
                  }}
                >
                  Client Management
                </NavLink>
              </Depth>
              <Depth>
                <NavLink
                  to='/client/dispatch'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Client dispatch schedule management
                </NavLink>
              </Depth>
              <Depth>
                <NavLink
                  to='/client/report'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Customer Report
                </NavLink>
              </Depth>
              <Depth>
                <NavLink
                  to='/client/meeting'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Minutes of Meeting
                </NavLink>
              </Depth>
              <Depth>
                <NavLink
                  to='/client/type'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Client Type
                </NavLink>
              </Depth>
              {(localStorage.getItem('userRank') === '9' || localStorage.getItem('userRank') === '0') &&
                <Depth>
                  <NavLink
                    to='/client/excel'
                    end={true}
                    className={({ isActive }) => {
                      return isActive ? 'active' : '';
                    }}
                >
                  Excel Reader
                </NavLink>
              </Depth>
              }
              <Depth>
                <NavLink
                    to='/client/checklist'
                    end={true}
                    className={({ isActive }) => {
                      return isActive ? 'active' : '';
                    }}
                >
                  CheckList Manage
                </NavLink>
              </Depth>
              <Depth>
                <NavLink
                    to='/client/checklist/retrieve'
                    end={true}
                    className={({ isActive }) => {
                      return isActive ? 'active' : '';
                    }}
                >
                  CheckList Retrieve
                </NavLink>
              </Depth>
              <Depth>
                <NavLink
                    to='/client/message'
                    end={true}
                    className={({ isActive }) => {
                      return isActive ? 'active' : '';
                    }}
                >
                  Customer Message
                </NavLink>
              </Depth>
              {/*<Depth>*/}
              {/*  <NavLink*/}
              {/*      to='/client/check'*/}
              {/*      end={true}*/}
              {/*      className={({ isActive }) => {*/}
              {/*        return isActive ? 'active' : '';*/}
              {/*      }}*/}
              {/*  >*/}
              {/*    Client Check*/}
              {/*  </NavLink>*/}
              {/*</Depth>*/}
              {/*<Depth>*/}
              {/*  <NavLink*/}
              {/*    to='/client/capture'*/}
              {/*    end={true}*/}
              {/*    className={({ isActive }) => {*/}
              {/*      return isActive ? 'active' : '';*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    Manage Client Capture*/}
              {/*  </NavLink>*/}
              {/*</Depth>*/}
            </DepthList>
          </ListItem>
          <ListItem>
            <ListBtn onClick={() => toggleNav(2)} $isOpen={navOpen[2]}>
              Workforce management
            </ListBtn>
            <DepthList $isOpen={navOpen[2]}>
              <Depth>
                <NavLink
                  to='/workforce/administrator'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Administrator Account Management
                </NavLink>
                <NavLink
                  to='/workforce/dispatch'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Dispatch Workforce Management
                </NavLink>
                <NavLink
                  to='/workforce/checkIn'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Check-in Management
                </NavLink>
                <NavLink
                  to='/workforce/checkOut'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Check-out Management
                </NavLink>
                <NavLink
                  to='/workforce/commute'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Commute Management (per period)
                </NavLink>
              </Depth>
            </DepthList>
          </ListItem>
          <ListItem>
            <ListBtn onClick={() => toggleNav(3)} $isOpen={navOpen[3]}>
              Storage Management
            </ListBtn>
            <DepthList $isOpen={navOpen[3]}>
              <Depth>
                <NavLink
                  to='/storage/product/type'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Product Type
                </NavLink>
                <NavLink
                  to='/storage/warehousing'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Status of Warehousing
                </NavLink>
                <NavLink
                  to='/storage/product/status'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Product Status
                </NavLink>
                <NavLink
                  to='/storage/product/checkout'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Product Check Out
                </NavLink>
                <NavLink
                  to='/storage/product/retrieval'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Product Retrieval
                </NavLink>
                <NavLink
                  to='/storage/product/statistics'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Statistics
                </NavLink>
              </Depth>
            </DepthList>
          </ListItem>
          <ListItem>
            <ListBtn onClick={() => toggleNav(4)} $isOpen={navOpen[3]}>
              TOB Sales Management
            </ListBtn>
            <DepthList $isOpen={navOpen[4]}>
              <Depth>
                <NavLink
                  to='/admin/employ'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Member Status
                </NavLink>
                <NavLink
                  to='/admin/sales'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Shopify Order Info
                </NavLink>
                <NavLink
                  to='/admin/recommand'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Customer info
                </NavLink>
                <NavLink
                  to='/admin/incentive'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Incentive
                </NavLink>
                <NavLink
                  to='/admin/best'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Best Item
                </NavLink>
                <NavLink
                  to='/admin/promo/manage'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Promo Code Manage
                </NavLink>
                <NavLink
                  to='/admin/promo/incentive'
                  end={true}
                  className={({ isActive }) => {
                    return isActive ? 'active' : '';
                  }}
                >
                  Promo Code Incentive
                </NavLink>
              </Depth>
            </DepthList>
          </ListItem>
        </NavList>
      </NavWrap>
    </>
  );
}

const NavWrap = styled.div`
  position: relative;
  max-width: 220px;
  min-width: 220px;
`;

const NavList = styled.ul`
  position: relative;
  width: 100%;
`;

const ListItem = styled.li`
  width: 100%;
`;

const ListBtn = styled.button`
  width: 100%;
  padding: 15px 25px;
  font-weight: 500;
  font-size: 16px;
  color: ${props => (props.$isOpen ? '#0072B9' : '#898989')};
  background: ${props => (props.$isOpen ? 'url("https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/nav_on.svg") top 11px left 0 no-repeat' : 'url("https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/nav_off.svg") top 11px left 0 no-repeat')};
  text-align: left;
`;

const DepthList = styled.ul`
  position: relative;
  width: 100%;
  opacity: 0;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  transition: ease-in-out all .3s;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      opacity: 1;
      height: auto;
      visibility: visible;
    `};
`;

const Depth = styled.li`
  width: 100%;

  & > a {
    display: block;
    padding: 15px 25px;
    background: #f8f8f8;
    font-weight: 300;
    font-size: 16px;
    color: #777777;
  }

  & > a.active {
    color: #0072B9;
    background: rgba(46, 148, 222, 0.15);
  }
`;

export default SideNav;
